module.exports = __webpack_public_path__ + "img/stema.501f9550.jpg";